function PlatformTitle(props){
    return <div className="platformTitle">{props.title ? props.title : props.children}</div>
}

export default PlatformTitle;